module.exports = [
 {
  "start": 41,
  "end": 2875,
  "text": "A la belle etoile or Under the Sky was initially "
 },
 {
  "start": 3000,
  "end": 4583,
  "text": "created for the square in front "
 },
 {
  "start": 4625,
  "end": 6500,
  "text": "of the Centre Georges Pompidou in Paris, "
 },
 {
  "start": 6667,
  "end": 9375,
  "text": "this work transports us up into the heavens "
 },
 {
  "start": 9458,
  "end": 12458,
  "text": "and yet the images appear beneath our feet. "
 },
 {
  "start": 12792,
  "end": 15208,
  "text": "The sky, rich in ancient stories, "
 },
 {
  "start": 15375,
  "end": 17542,
  "text": "features in a number of my videos. "
 },
 {
  "start": 17667,
  "end": 19625,
  "text": "The boundary between the inside "
 },
 {
  "start": 19708,
  "end": 23041,
  "text": "and outside of the body is dissolved into atoms; "
 },
 {
  "start": 23166,
  "end": 25959,
  "text": "so too is the idea that we are separate "
 },
 {
  "start": 26041,
  "end": 28625,
  "text": "from the air or the environment. "
 },
 {
  "start": 28875,
  "end": 31458,
  "text": "I am much more interested in the inner worlds "
 },
 {
  "start": 31542,
  "end": 34375,
  "text": "than trying to copy so called reality. "
 },
 {
  "start": 35834,
  "end": 38208,
  "text": "I want to understand what you see "
 },
 {
  "start": 38333,
  "end": 40125,
  "text": "when you close your eyes."
 },
 {
  "start": 40250,
  "end": 42625,
  "text": "i don't think artists have more fantasy "
 },
 {
  "start": 42708,
  "end": 45667,
  "text": "than not artists but it is our profession "
 },
 {
  "start": 45708,
  "end": 49625,
  "text": "to take it seriously and try to materialize it"
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room6/audio1/06_MCA A La Belle Etoile.js